/**
 * Redux reducer for saving application state.
 * @module redux/reducers/savedState
 */

import update from "immutability-helper";
import {
  LOAD,
  LOAD_FAILED,
  LOADED,
  UPDATE,
  RESTORE
} from "../actions/savedState";
import { PRIME_STYLE_CHANGED as ASSET_PRIME_STYLE_CHANGED } from "../actions/asset";
import {
  ASSET_TYPE_CHANGED as TEMPLATE_ASSET_TYPE_CHANGED,
  SEARCH_TYPE_CHANGED as TEMPLATE_SEARCH_TYPE_CHANGED,
  ACTIVE_VIEW_CHANGED as TEMPLATE_ACTIVE_VIEW_CHANGED,
  CONTEXT_CHANGED as TEMPLATE_CONTEXT_CHANGED,
  CATEGORY_CHANGED as TEMPLATE_CATEGORY_CHANGED,
  CATEGORIES_CHANGED as TEMPLATE_CATEGORIES_CHANGED,
  FILTER_BY_CHANGED as TEMPLATE_FILTER_BY_CHANGED,
  SORT_BY_CHANGED as TEMPLATE_SORT_BY_CHANGED
} from "../actions/assets";
import {
  QUEUE_CONTENT_REQUEST as CONTENT_QUEUE_CONTENT_REQUEST,
  ACTIVE_VIEW_CHANGED as CONTENT_ACTIVE_VIEW_CHANGED,
  CONTEXT_CHANGED as CONTENT_CONTEXT_CHANGED,
  CATEGORY_CHANGED as CONTENT_CATEGORY_CHANGED,
  CATEGORIES_CHANGED as CONTENT_CATEGORIES_CHANGED,
  FILTER_BY_CHANGED as CONTENT_FILTER_BY_CHANGED,
  SORT_BY_CHANGED as CONTENT_SORT_BY_CHANGED
} from "../actions/content";
import { TEMPLATE_DEFINITION_LOADED } from "../actions/asset";

const initialState = {
  savedState: {},
  savedStateLoading: false,
  lastLocalChange: null,
  lastSave: null,
  restored: false
};

const ACTION_HANDLERS = {
  [LOAD]: state => ({
    ...state,
    savedState: {},
    savedStateLoading: true
  }),
  [LOAD_FAILED]: state => ({
    ...state,
    savedStateLoading: false
  }),
  [LOADED]: (state, action) => ({
    ...state,
    savedState: action.payload.savedState,
    savedStateLoading: false,
    restored: false
  }),
  [UPDATE]: (state, action) => ({
    ...state,
    savedState: action.payload.savedState,
    lastSave: Date.now()
  }),
  [RESTORE]: state => ({
    ...state,
    restored: true
  })
};

const stateChangeHandler = (state, action) => {
  switch (action.type) {
    case ASSET_PRIME_STYLE_CHANGED:
    case TEMPLATE_ASSET_TYPE_CHANGED:
    case TEMPLATE_ACTIVE_VIEW_CHANGED:
    case TEMPLATE_CATEGORY_CHANGED:
    case TEMPLATE_CATEGORIES_CHANGED:
    case TEMPLATE_CONTEXT_CHANGED:
    case TEMPLATE_FILTER_BY_CHANGED:
    case TEMPLATE_SEARCH_TYPE_CHANGED:
    case TEMPLATE_SORT_BY_CHANGED:
    case CONTENT_QUEUE_CONTENT_REQUEST:
    case CONTENT_ACTIVE_VIEW_CHANGED:
    case CONTENT_CATEGORY_CHANGED:
    case CONTENT_CATEGORIES_CHANGED:
    case CONTENT_CONTEXT_CHANGED:
    case CONTENT_FILTER_BY_CHANGED:
    case CONTENT_SORT_BY_CHANGED:
      return {
        ...state,
        lastLocalChange: Date.now()
      };
    default:
      return state;
  }
};

export default function savedState(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type] || stateChangeHandler;

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/savedState.js